import React, { useState, useEffect } from "react";
import { DDXModal } from "components/ddx-modal/DDXModal";
import ButtonIcon from "components/utility/button/ButtonIcon";
import * as PageResponsive from "components/utility/page-responsive/PageResponsive";

type LightBoxContentProps = {
	data: {
		src: string;
		alt: string;
	};
};

const LightBoxContent = ({ data }: LightBoxContentProps) => {
	const { src, alt } = data;
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [zoomToggle, setZoomToggle] = useState(true);
	const [isDesktop, setIsDesktop] = useState(false);
	const [style, setStyle] = useState<React.CSSProperties>({ maxWidth: "60rem" });
	const [widthInitial, setWidthInitial] = useState(960);
	const [isSmallImage, setIsSmallImage] = useState(false);
	const [isVerticalImage, setIsVerticalImage] = useState(false);
	const [maxWidth, setMaxWidth] = useState(60);

	const openModal = () => {
		setModalIsOpen(true);
	};
	const closeModal = () => {
		setModalIsOpen(false);
		setStyle({ maxWidth: isVerticalImage ? "60rem" : "30rem" });
	};
	const onImgLoad = ({ target: img }) => {
		setWidthInitial(img.naturalWidth);
		//if the image is small, if the image is vertical
		if (img.width > img.height) {
			setIsVerticalImage(false);
			if (img.width > img.naturalWidth) {
				setIsSmallImage(true);
			} else {
				setIsSmallImage(false);
			}
		} else {
			setIsVerticalImage(true);
			setStyle({ maxWidth: "30rem" });
			setMaxWidth(30);
			img.height > img.naturalHeight ? setIsSmallImage(true) : setIsSmallImage(false);
		}
	};
	const toggleZoom = () => {
		if (isDesktop) {
			setZoomToggle(!zoomToggle);
			//if zoom it out
			if (zoomToggle === true) {
				//if small image
				if (isSmallImage) {
					setStyle({
						width: `${maxWidth * 2}rem`,
						height: "",
						maxWidth: `${maxWidth * 2}rem`
					});
				} else {
					setStyle({ width: widthInitial });
				}
			} else {
				setStyle({
					width: "100%",
					height: "",
					maxWidth: `${maxWidth}rem`
				});
			}
		}
	};
	const handleResize = () => {
		if (PageResponsive.isDesktop() === true) {
			setIsDesktop(true);
		} else {
			setIsDesktop(false);
			setZoomToggle(false);
		}
	};
	const handleKeyPressEnterModal = (e) => {
		const key = e.which || e.keyCode || 0;
		if (key === 13 || key === 32) {
			e.preventDefault();
			openModal();
		}
	};
	const handleKeyPressEnterZoom = (e) => {
		const key = e.which || e.keyCode || 0;
		if (key === 13 || key === 32) {
			e.preventDefault();
			toggleZoom();
		}
	};

	useEffect(() => {
		handleResize();
		window.addEventListener("resize", handleResize);
		return window.removeEventListener("resize", handleResize);
	});

	return (
		<>
			{src ? (
				<div className="lightbox-container">
					<img
						src={src}
						alt={alt}
						onClick={openModal}
						onKeyDown={handleKeyPressEnterModal}
						role="presentation"
						aria-label="image"
					/>
					<DDXModal
						className="lightbox-dialog"
						handleCloseModal={closeModal}
						showModal={modalIsOpen}
					>
						<div className={"lightbox lightbox-" + zoomToggle} style={{ ...style }}>
							<ButtonIcon
								type="close"
								className="lightbox-close"
								color="white"
								onClick={closeModal}
							/>
							<div
								className="lightbox-image-container"
								onClick={toggleZoom}
								onKeyDown={handleKeyPressEnterZoom}
								role="button"
								aria-label="lightbox"
								tabIndex={0}
							>
								<img
									className={"lightbox-image lightbox-image-" + zoomToggle}
									src={src}
									alt={alt}
									onLoad={onImgLoad}
								/>
							</div>
						</div>
					</DDXModal>
				</div>
			) : null}
		</>
	);
};

export default LightBoxContent;
